export default __webpack_public_path__ + "static/media/bazzle.87a9a716.png";